import * as LucideIcons from 'lucide-react';
import { HelpCircle, AlertCircle } from 'lucide-react';
import React from 'react';

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    // Handle error cases gracefully
    if (!name || typeof name !== 'string') {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    const IconComponent = LucideIcons?.[name];

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found in Lucide React. Using fallback icon.`);
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    try {
        return <IconComponent
            size={size}
            color={color}
            strokeWidth={strokeWidth}
            className={className}
            {...props}
        />;
    } catch (error) {
        console.error(`Error rendering icon "${name}":`, error);
        // Return a simple div instead of another icon to avoid recursion
        return <div 
            className={`inline-flex items-center justify-center ${className}`}
            style={{ width: size, height: size }}
            title={`Icon "${name}" failed to load`}
        >
            ⚠️
        </div>;
    }
}

export default Icon;